export const PROMOTED_CATEGORY_TYPES = [
  "artForms",
  "artisticPeriods",
  "artisticPeriodsSubCats",
] as const;

export type PromotedCategoryType = (typeof PROMOTED_CATEGORY_TYPES)[number];

export type PromotedCategory = {
  category: string;
  img: string;
  type: PromotedCategoryType;
};

export function isPromotedCategoryType(
  value: unknown,
): value is PromotedCategoryType {
  return (
    typeof value === "string" &&
    (PROMOTED_CATEGORY_TYPES as readonly string[]).includes(value)
  );
}

export function parsePromotedCategories(value: unknown): PromotedCategory[] {
  if (!Array.isArray(value)) return [];

  const items: PromotedCategory[] = [];
  for (const entry of value) {
    if (!entry || typeof entry !== "object") continue;
    const row = entry as Record<string, unknown>;
    const category = typeof row.category === "string" ? row.category.trim() : "";
    const img = typeof row.img === "string" ? row.img.trim() : "";
    const type = row.type;
    if (!category || !isPromotedCategoryType(type)) continue;
    items.push({ category, img, type });
  }
  return items;
}
